/* eslint-disable prettier/prettier */
import requests from "./httpServices";

class MyTeamService {
    myTeam(headers) {
        return requests.get('/secure/teams', headers)
    }
    refferal(headers) {
        return requests.get('/secure/teams', headers)
    }
}

export default new MyTeamService();